import { IsString, IsNotEmpty, IsOptional } from 'class-validator';

// JSON-safe type definitions
export type JSONValue =
  | string
  | number
  | boolean
  | null
  | JSONObject
  | JSONValue[];
export interface JSONObject {
  [key: string]: JSONValue;
}

// Audit log interface
export interface AuditLog {
  id: string;
  entityType: string; // 'post', 'asset', 'comment', etc.
  entityId: string;
  action: string; // 'create', 'update', 'delete'
  userId?: string;
  userName?: string;
  timestamp: string;
  changes?: {
    before?: JSONObject;
    after?: JSONObject;
  };
  metadata?: JSONObject;
}

// Create audit log DTO
export class CreateAuditLogDto {
  @IsString()
  @IsNotEmpty()
  entityType: string;

  @IsString()
  @IsNotEmpty()
  entityId: string;

  @IsString()
  @IsNotEmpty()
  action: string;

  @IsOptional()
  @IsString()
  userId?: string;

  @IsOptional()
  @IsString()
  userName?: string;

  @IsOptional()
  changes?: {
    before?: JSONObject;
    after?: JSONObject;
  };

  @IsOptional()
  metadata?: JSONObject;
}
